import { css } from '@emotion/react'
import {
	Button as JikeButton,
	type ButtonProps as JikeButtonProps,
} from '@ruguoapp/jike-fe-components'

export interface ButtonProps extends Omit<JikeButtonProps, 'appearance'> {
	appearance?: 'glass' | JikeButtonProps['appearance']
}

export default function Button({ appearance, ...props }: ButtonProps) {
	return (
		<JikeButton
			{...props}
			appearance={appearance as JikeButtonProps['appearance']}
			css={css`
				&.jk-btn-glass {
					background: rgb(0 0 0 / 16%);
					backdrop-filter: blur(6px);
					border: 1px solid var(--solid-separator, rgb(255 255 255 / 20%));
					color: var(--solid-white-1);
					transition: background 0.3s;

					&:hover {
						background: rgb(0 0 0 / 32%);
					}
				}
			`}
		/>
	)
}
